import React, { useContext } from 'react';
import copy from 'copy-to-clipboard';
import PosicoesContext from '../../../../../context/posicoes.context';
import { notify } from '../../../../../functions/notifications';
import './coleta.scss';

function Coleta() {
  const {
    temp, setNowCoordenadas, setInput, input, nowCoordenadas,
    setarInformacoes, verificaColeta, setCheckNumber,
  } = useContext(PosicoesContext);

  return (
    <div id="coletas">
      <div className="separator">
        <span>
          Coletas
        </span>
      </div>
      <div className="inputs-coleta">
        <label id="label-descricaoColeta" className="descricaoColeta">
          <span>
            Descrição
          </span>
          <input
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
            value={input.descricaoColeta}
            type="text"
            required
            id="descricaoColeta"
            name="descricaoColeta"
            placeholder="Informa e descrição"
          />
        </label>
        <label id="label-latitude" className="latitude">
          <span>
            Latitude
          </span>
          <input
            onChange={(e) => {
              const { target: { value } } = e;
              const maxLenght = value.length > 19;
              if (!maxLenght) {
                setCheckNumber({ type: 'lat', value });
                setNowCoordenadas((prevState) => ({ ...prevState, lat: value }));
              }
            }}
            value={nowCoordenadas?.lat}
            type="text"
            id="latitude"
            name="latitude"
            placeholder="ex. -21.83586"
          />
        </label>
        <label id="label-longitude" className="longitude">
          <span>
            Longitude
          </span>
          <input
            onChange={(e) => {
              const { target: { value } } = e;
              const maxLenght = value.length > 19;
              if (!maxLenght) {
                setCheckNumber({ type: 'lng', value });
                setNowCoordenadas((prevState) => ({ ...prevState, lng: value }));
              }
            }}
            type="text"
            id="longitude"
            name="longitude"
            placeholder="ex. -46.89113"
            value={nowCoordenadas?.lng}
          />
        </label>
        <div className="button-copy">
          <button
            onClick={() => {
              if (temp.positions[0].lat !== 0 && temp.positions[0].lng !== 0) {
                copy(`${temp.positions[0].lat}, ${temp.positions[0].lng}`);
                notify('success', 'Coordenadas copiadas');
              } else {
                notify('warning', 'Indique uma posição no mapa para realizar a copia.');
              }
            }}
            className="buttons-transparent"
            type="button"
          >
            <i className="far fa-copy" />
          </button>
        </div>
        <label id="id-input-coleta" htmlFor="id-input-coleta">
          <span>Importar KML</span>
          <input
            name="kml"
            type="file"
            onChange={() => {}}
          />
        </label>
        <button
          id="selecionar-mapa"
          type="button"
          data-dismiss="modal"
        >
          <span>
            Seleciona no Mapa
          </span>
        </button>
        <button
          onClick={() => {
            if (temp.positions[0]?.lat !== 0) {
              verificaColeta();
            } else {
              notify('warning', 'Ops!!!, você náo informou a posição no mapa, revise.');
            }
          }}
          id="salvar-button"
          type="button"
        >
          <span>
            Salvar Dados
          </span>
        </button>
      </div>
    </div>
  );
}

export default Coleta;
